import React from "react";
import { STATUS_LABELS } from "../../Helper/Cotizacion/quoteModel";

const COLORS = {
	borrador: { bg: "#fff3cd", color: "#856404" },
	emitida: { bg: "#d4edda", color: "#155724" },
	anulada: { bg: "#f8d7da", color: "#721c24" },
};

const CotizacionStatusBadge = ({ status }) => {
	const palette = COLORS[status] || { bg: "#e2e8f0", color: "#2d3748" };
	return (
		<span
			style={{
				display: "inline-block",
				padding: "2px 10px",
				borderRadius: "12px",
				fontSize: "12px",
				fontWeight: 600,
				backgroundColor: palette.bg,
				color: palette.color,
			}}
		>
			{STATUS_LABELS[status] || status}
		</span>
	);
};

export default CotizacionStatusBadge;
